import getOr from "lodash/fp/getOr";
import { nFormatter } from "../utils/utils";

export class TariffDetail {
  constructor(agreementId, agreementName, ftaId, hasFtaDetails, hasTrq, tariffAve, valueText, valueTextRaw, total, totalText, totalTextRaw, isNotApply, hint, highlight) {
    this.agreementId = agreementId;
    this.agreementName = agreementName;
    this.ftaId = ftaId;
    this.hasFtaDetails = hasFtaDetails;
    this.hasTrq = hasTrq;
    this.tariffAve = tariffAve;
    this.valueText = valueText;
    this.valueTextRaw = valueTextRaw;
    this.total = total;
    this.totalText = totalText;
    this.totalTextRaw = totalTextRaw;
    this.isNotApply = isNotApply;
    this.hint = hint;
    this.highlight = highlight;
  }
  static fromApiObject(input, currency) {
    if (typeof (input) === "object" && input !== null) {
      const agreementId = getOr("", "agreementId")(input);
      const agreementName = getOr("", "name")(input) || getOr("", "agreementName")(input);
      const ftaId = getOr("", "ftaId")(input);
      const hasFtaDetails = getOr("", "hasFtaDetails")(input);
      const hasTrq = getOr("", "hasTrq")(input);
      const tariffAve = getOr("", "value")(input) || getOr("", "tariffAve")(input);
      // const realCurrency = getOr(currency, "currency")(input);
      // const unit = getOr("", "unit")(input) || "%";
      // const valueText = `${unit === "%" ? "" : realCurrency + " "}${nFormatter(tariffAve, 2)} ${(unit + "").toLowerCase()}`;
      const valueText = getOr("", "duty")(input);
      // const valueTextRaw = `${unit === "%" ? "" : realCurrency + " "}${tariffAve * 1} ${(unit + "").toLowerCase()}`;
      const valueTextRaw = getOr("", "duty")(input);
      const total = getOr("", "amount")(input);
      const totalText = `<span class="currency">${currency}</span> ${nFormatter(total, 2)}`;
      const totalTextRaw = currency + " " + total * 1;
      return new TariffDetail(agreementId, agreementName, ftaId, hasFtaDetails, hasTrq, tariffAve, valueText, valueTextRaw, total, totalText, totalTextRaw, !input.is_applied, input.hint, input.highlight);
    }
    return new TariffDetail();
  }
  static fromApiArray(input, currency) {
    if (Array.isArray(input)) {
      return input.map(item => TariffDetail.fromApiObject(item, currency));
    }
    if (typeof (input) === "object" && input !== null) {
      return [TariffDetail.fromApiObject(input, currency)];
    }
    return [];
  }
}